import React, { useEffect, useState, useRef } from "react";
import MenuComponent from "./Menu.component";
import { fetchCastingMenuCountInfo, fetchHubMenuCountInfo, fetchMenuCountInfo } from "api/student/v2/menu.api";
import { useLocation } from "react-router-dom";

const MenuContainer = (props: any) => {
    const location = useLocation();
    const { needNoMenu } = props;
    const [showCastingBadge, setShowCastingBadge] = useState(false);
    const [showMessageBadge, setShowMessageBadge] = useState(false);
    const [showHubBadge, setShowHubBadge] = useState(false);
    const [showMagazineBadge, setShowMagazineBadge] = useState(false);
    const [showNoticeBadge, setShowNoticeBadge] = useState(false);
    const [showTodayDiaryBadge, setShowTodayDiaryBadge] = useState(false);
    const [showCastingLogBadge, setShowCastingLogBadge] = useState(false);
    const [showEventBadge, setShowEventBadge] = useState(false);

    const isLoadingMenuRef = useRef(false);
    
    // 메인 메뉴용 카운트 정보 조회
    useEffect(() => {
        const getMenuCountInfo = async () => {
            // 이미 호출 중이면 재호출하지 않음
            if (isLoadingMenuRef.current) {
                return;
            }

            try {
                isLoadingMenuRef.current = true;
                console.log("getMenuCountInfo");
                const data = await fetchMenuCountInfo();
                console.log("getMenuCountInfo", { data });
                if (data) {
                    setShowCastingBadge(
                        data.messageRequestCount > 0 ||
                        data.notReadMessageCount > 0);

                    // 오늘 날짜가 2026년 2월 17일 이전일 경우 true, 아닐 경우 false
                    const now = new Date();
                    const eventEnd = new Date("2026-02-17T00:00:00+09:00");
                    const hasRunningEvent = now < eventEnd;
                    setShowHubBadge(
                        // data.newNoticeCount > 0 ||
                        data.newMagazineCount > 0 ||
                        data.newCastingLogCount > 0 ||
                        hasRunningEvent);
                    setShowTodayDiaryBadge(data.todayDiaryCount == 0);
                } else {
                    setShowHubBadge(false);
                    setShowCastingBadge(false);
                    setShowTodayDiaryBadge(false);
            
                }
            } catch (error) {
                console.error("메뉴 카운트 정보 조회 실패:", error);
                setShowCastingBadge(false);
                setShowHubBadge(false);
            
            } finally {
                isLoadingMenuRef.current = false;
            }
        };

        if (location.pathname == '/student') {
            getMenuCountInfo();
            const interval = setInterval(() => {
                getMenuCountInfo();
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [location]);

    const isLoadingCastingRef = useRef(false);

    // 캐스팅 메뉴용 카운트 정보 조회
    useEffect(() => {
        const getCastingMenuCountInfo = async () => {
            // 이미 호출 중이면 재호출하지 않음
            if (isLoadingCastingRef.current) {
                return;
            }

            try {
                isLoadingCastingRef.current = true;
                const data = await fetchCastingMenuCountInfo();
                console.log({ data });
                setShowMessageBadge(data.notReadMessageCount > 0
                    || data.messageRequestCount > 0);
            } catch (error) {
                console.error("메뉴 카운트 정보 조회 실패:", error);
                setShowMessageBadge(false);
            } finally {
                isLoadingCastingRef.current = false;
            }
        };

        if (location.pathname.startsWith('/student/casting')) {
            getCastingMenuCountInfo();
            const interval = setInterval(() => {
                getCastingMenuCountInfo();
            }, 10000);
            return () => clearInterval(interval);
        }

        if (location.pathname.startsWith('/student/casting/message')) {
            setShowMessageBadge(false);
        }
    }, [location]);

    const isLoadingHubRef = useRef(false);

    // 허브 메뉴용 카운트 정보 조회
    useEffect(() => {
        const getHubMenuCountInfo = async () => {
            // 이미 호출 중이면 재호출하지 않음
            if (isLoadingHubRef.current) {
                return;
            }

            try {
                isLoadingHubRef.current = true;
                const data = await fetchHubMenuCountInfo();
                console.log({ data });
                setShowNoticeBadge(data.newNoticeCount > 0);
                setShowMagazineBadge(data.newMagazineCount > 0);
                setShowCastingLogBadge(data.newCastingLogCount > 0);

                // 오늘 날짜가 2026년 2월 17일 이전일 경우 true, 아닐 경우 false
                const now = new Date();
                const eventEnd = new Date("2026-02-17T00:00:00+09:00");
                const hasRunningEvent = now < eventEnd;
                setShowEventBadge(hasRunningEvent);
            } catch (error) {
                console.error("메뉴 카운트 정보 조회 실패:", error);
                setShowNoticeBadge(false);
                setShowMagazineBadge(false);
                setShowCastingLogBadge(false);
                setShowEventBadge(false);
            } finally {
                isLoadingHubRef.current = false;
            }
        };

        if (location.pathname.startsWith('/student/hub')) {
            getHubMenuCountInfo();
            const interval = setInterval(() => {
                getHubMenuCountInfo();
            }, 10000);
            return () => clearInterval(interval);
        }
        if (location.pathname.startsWith('/student/hub/casting-log')) {
            setShowCastingLogBadge(false);
        } else if (location.pathname.startsWith('/student/hub/magazine')) {
            setShowMagazineBadge(false);
        } else if (location.pathname.startsWith('/student/my/notice')) {
            setShowNoticeBadge(false);
        }
    }, [location]);

    return <MenuComponent
        showCastingBadge={showCastingBadge}
        showHubBadge={showHubBadge}
        showMessageBadge={showMessageBadge}
        showNoticeBadge={showNoticeBadge}
        showMagazineBadge={showMagazineBadge}
        showTodayDiaryBadge={showTodayDiaryBadge}
        showCastingLogBadge={showCastingLogBadge}
        showEventBadge={showEventBadge}
        needNoMenu={needNoMenu} />;
};

export default MenuContainer;